export default __webpack_public_path__ + "fonts/login_1.97f0292f25d4fc5e2f55a969b12ea54b.png";